import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';

import api from 'api';
import WP from 'WP';
import Builder from 'partials/Builder';
import HeadMeta from 'partials/HeadMeta';
import Loader from 'partials/Loader';

import { addToPages, setCurrentView } from 'store';

class Home extends Component {

    constructor() {
        super();

        this.state = {
            page: null
        }

    }

    componentWillMount() {
        this.mounted = true;

        const frontPageId = WP.front_page;
        if(this.props.storedPages[frontPageId]) {
            if(this.mounted) this.setState({ page: this.props.storedPages[frontPageId] });
            //console.log('home loaded from store', this.props.storedPages[frontPageId]);
            this.props.setCurrentView(this.props.storedPages[frontPageId]);
            return;
        }

        api.getHomePage()
            .then(resp => {
                if(resp.data.id) {
                    //console.log('HOME: ', resp.data);
                    if(this.mounted) this.setState({ page: resp.data });
                    this.props.setCurrentView(resp.data);
                    this.props.addToPages({
                        page: resp.data,
                        key: resp.data.id
                    });
                } else {
                    this.props.history.replace('/404');
                }
            })
            .catch(e => console.log(e));
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    _formatMeta() {
        const { page } = this.state;
        const title = page ?
            page.yoast && page.yoast.title ?  page.yoast.title : 'HLM'
            : '';
        return {
            title: title,
            description: '',
            ogUrl: '',
            ogType: '',
            ogTitle: '',
            ogDescription: '',
            ogImage: ''
        }
    }

    render() {
        const { page } = this.state;
        
        return (
            <Wrapper>

                <HeadMeta {...this._formatMeta.bind(this)() }/>

                <Loader loaded={page} />

                {page &&
                    <Builder data={page.acf.modules} />
                }
            </Wrapper>
        );
    }
}

const mapStateToProps = state => {
    return {
        storedPages: state.pages
    }
}

const actions = {
    addToPages,
    setCurrentView
}

export default connect(mapStateToProps, actions)(withRouter(Home));

const Wrapper = styled.div`
    display:block;
    position:relative;
    width:100%;
`


// WEBPACK FOOTER //
// ./src/views/Home.js